export default __webpack_public_path__ + "static/media/hatha_yoga.2ed5c231.png";